
import {functions} from "@/scripts/firebase";
import {getDocs} from 'firebase/firestore'
import {httpsCallable} from 'firebase/functions'
import { ModalAlertProps, ModalConfirmProps, NoticeProps,UserListUser} from "@/scripts/datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator";
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'
import ModalAlert from "@/components/ModalAlert.vue"
import ModalConfirm from "@/components/ModalConfirm.vue"
import { AuthMethod, InvitationToken, Role, SendInvitationArg, SendInvitationRes, UserNotificationMethods, UserNotifications, UserNotificationTypes, UserPrivateProfile, UserPublicProfile ,UserRelationship, UserSettings} from "@/common-datatypes";

interface SelectedFilter {
  role: Role | null;
  status: string | null; 
  searchText: string;
}

@Component({
  components: {
    ModalAlert,
    ModalConfirm
  }
})

export default class UserList extends Mixins(Common) {
  users: UserListUser[] = []
  isLoading = false
  notice: NoticeProps = {}
  showModalConfirm = false
  showModalAlert = false
  modalConfirm: ModalConfirmProps = {
    title: 'userList.sendInvitationSMS',
    message: '',
    isLoading: false
  }

  selectedFilter: SelectedFilter = {
    searchText: '',
    role: null,
    status: null
  }

  invitationTokens: InvitationToken[] = []

  modalAlert: ModalAlertProps = {title: 'userList.error',message: 'userList.noNeedSendSMSDescription'}
	usersNotifications: UserNotifications[] = []

  @Watch('selectedFilter',{deep: true})
 changeSelectedFilter(newVal: SelectedFilter){
  this.setFilter(newVal)
 }

setFilter(filter: SelectedFilter){
  this.users = this.users.map((user) => {
    user.hidden = false
    
    if(filter.searchText){
      if(this.$findTextByUserProfile(filter.searchText, user)){
        user.hidden = false
      }else{
        user.hidden = true
        return user
      }
    }

    if(filter.role){
      if(user.roles?.includes(filter.role)){
        user.hidden = false
      }else{
        user.hidden = true
        return user
      }
    }

    if(filter.status){
      switch(filter.status){
        case 'inviting':
          if(user.inviting){
            user.hidden = false
          }else{
            user.hidden = true
            return user
          }
          break
        case 'disabled':
          if(user.disabled){
            user.hidden = false
          }else{
            user.hidden = true
            return user
          }
          break
        case 'previewRequired':
          if(user.previewRequired){
            user.hidden = false
          }else{
            user.hidden = true
            return user
          }
          break
        case 'uninvited':
          if(user.inviting === false && user.disabled === false && ! user.uid){
            user.hidden = false
          }else{
            user.hidden = true
            return user
          }
          break
      }
    }

    return user
  })
 }

 existsStatus(status: 'disabled' | 'inviting' | 'uninvited' | 'reviewRequired'){
  return this.users.some((user) => {
    if(status === 'uninvited'){
      return user.inviting === false && user.disabled === false && ! user.uid
    }else if(user[status as keyof UserListUser]){
      return true
    }
    return false
  })
 }

 getNoticationsByMethod(method: keyof UserNotificationMethods, userId: string){
   const notifications = this.usersNotifications.find((user) => user.userId === userId)
   const type: (keyof UserNotificationTypes)[] = ['messages','reminders','events']

  if(notifications){
    return type.filter((t) => {
      return notifications[t] && notifications[t][method] === true
    })
  }

  return []
 }

  @Watch('invitationTokens')
  changeInvitationTokens(tokens: InvitationToken[]){
    this.users = this.users.map((user) => {
      if(tokens.some((token) => token.userId === user.userId)){
        user.inviting = true
      }else{
        user.inviting = false
      }
      return user
    })
    this.setFilter(this.selectedFilter)
  }
  
  get observer(){
    return this.$refs.userListSearchFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  downloadCSV() {
    //console.log(this.users)
    //var csv = '\ufeff' + '品名,価格\n'
    let csv = ''

    const header = [
      'lastName',
      'lastNameYomigana',
      'firstName',
      'firstNameYomigana',
      'email',
      'phoneNumber',
      'roles',
      'userId'
    ]

    csv = '"' + header.join('","') + '"\n'

    this.users.forEach((user) => {
      const line = [
        user.lastName,
        user.lastNameYomigana,
        user.firstName,
        user.firstNameYomigana,
        user.email,
        user.phoneNumber,
        user.roles?.join(','),
        user.userId
      ]
      csv += '"' + line.join('","') + '"\n'
    })

    const fileName = [
      this.$store.getters.schoolName,
      '_userlist_',
      this.$dateTimeFormat(new Date(), 'yyyyMMddHHmmss'),
      '.csv'
    ].join('')

    const blob = new Blob([csv], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{

      const [usersPublicProfileDocs, usersPrivateProfileDocs,usersRelationshipDocs,userNotificationsDocs,usersSettingsDocs] = await Promise.all([
        getDocs(this.$getUsersPublicProfileQuery()),
        getDocs(this.$getUsersPrivateProfileQuery()),
        getDocs(this.$getUsersRelationshipQuery()),
        getDocs(this.$getUsersNotificationsQuery()),
        getDocs(this.$getUsersSettingsQuery())
      ])

      const usersPublicProfile = usersPublicProfileDocs.docs.map((doc) => {
        return doc.data() as UserPublicProfile
      })

      const usersPrivateProfile = usersPrivateProfileDocs.docs.map((doc) => {
        return doc.data() as UserPrivateProfile
      })

      const usersRelationship = usersRelationshipDocs.docs.map((doc) => {
        return doc.data() as UserRelationship
      })

      this.usersNotifications = userNotificationsDocs.docs.map((doc) => {
        return doc.data() as UserNotifications
      })

      const usersSettings = usersSettingsDocs.docs.map((doc) => {
        return doc.data() as UserSettings
      })

      usersPublicProfile.forEach((userPublicProfile) => {
        let user = {} as UserListUser
        const userId = userPublicProfile.userId
        const userPrivateProfile = usersPrivateProfile.find((userPrivateProfile) => {
          return userId && userPrivateProfile.userId === userId
        })

        const userRelationship = usersRelationship.find((userRelationship) => {
          return userId && userRelationship.userId === userId
        })

        const userSettings = usersSettings.find((userSettings) => {
          return userId && userSettings.userId === userId
        })

        if(userPrivateProfile){
          user = {...user,...userPrivateProfile}
        }

        if(userRelationship){
          user = {
            ...user,
            family: userRelationship.family,
            familyMeta: userRelationship.familyMeta
          }
        }

        if(userSettings){
          user = {
            ...user,
            previewRequired: userSettings.previewRequired || false,
          }
        }

        user = {...user,...userPublicProfile}

        this.users.push(user)
        user.roles?.forEach((role) => {
          this.roleCount[role] ++
        })
      })

      this.sortUser()
      await this.getInvitationToken()
    }catch(error){
      console.table(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  async getInvitationToken(){
    try{
      const invitationTokens = await getDocs(this.$getInvitationTokenQuery(this.$store.getters.schoolId,'schoolId'))

      this.invitationTokens = invitationTokens.docs.map((doc) => {
        const data = doc.data() as InvitationToken
        return {...data,id: doc.id}
      })
    }catch(error){
      console.log(error)
    }
  }

  showModalSendInvitation(userId: string, method: AuthMethod){
    if(userId && method){
      const theUser = this.users.find((user) => {
        return user.userId === userId
      })
      if(theUser && method === 'phoneNumber' && theUser[method]){
        this.modalConfirm.title = 'userList.sendInvitationSMS'
        this.modalConfirm.message = (this.$t('text.name',{lastName: theUser.lastName, firstName: theUser.firstName}) as string) + '<br>' + (this.$t('userList.sendInvitationSMSDescription',{phoneNumber: theUser.phoneNumber}) as string)
        this.modalConfirm.args = {userId: userId, method: method}
        this.showModalConfirm = true
        return
      }
      if(theUser && method === 'email' && theUser[method]){
        this.modalConfirm.title = 'userList.sendInvitationEmail'
        this.modalConfirm.message = (this.$t('text.name',{lastName: theUser.lastName, firstName: theUser.firstName}) as string) + '<br>' + (this.$t('userList.sendInvitationEmailDescription',{email: theUser.email}) as string)
        this.modalConfirm.args = {userId: userId, method: method}
        this.showModalConfirm = true
      }
    }
  }

  async sendInvitation(args: {userId: string; method: AuthMethod} | false){
    if(args !== false && args.userId && args.method ){
      try{
        this.$store.commit("setLoading",true)
        this.$set(this.modalConfirm,'isLoading',true)

        const sendInvitation = httpsCallable(functions,'sendInvitation')

        const sentInvitation = await sendInvitation({
          userId: args.userId,
          schoolId: this.$store.getters.schoolId,
          schoolName: this.$store.getters.schoolName,
          method: args.method,
        } as SendInvitationArg) as {data: SendInvitationRes}

        if(sentInvitation.data){
          this.modalAlert.title = 'message.sent'
          this.modalAlert.message = (args.method === 'phoneNumber') ? 'userList.sentInvitationSMS' :  'userList.sentInvitationEmail'
          this.showModalAlert = true
        }else{
          throw {code: (args.method === 'phoneNumber') ? 'userList.unableToSendSMS' : 'userList.unableToSendEmail'}
        }
      }catch(error){
        this.modalAlert.title = 'message.error'
        const errorCode = this.$getErrorCode(error)
        console.log(JSON.stringify(error))
        this.modalAlert.message = this.$getErrorMessageKey(errorCode)
        this.showModalAlert = true
      }finally{
        this.$set(this.modalConfirm,'isLoading',false)
        this.$store.commit("setLoading",false);
        this.isLoading = false
        await this.getInvitationToken()
      }
    }
    this.showModalConfirm = false
  }


  sortUser(){
    /**
     * ラストログインタイム
     * 生徒
     * 教務
     * 
     */

    this.users.sort((a, b) => {
      const A = a.lastSignInTime?.toMillis() || Number.MIN_SAFE_INTEGER
      const B = b.lastSignInTime?.toMillis() || Number.MIN_SAFE_INTEGER
      return B - A
    }).sort((a, b) => {
      const A = (a.roles || []).reduce((prev,current) => {
        const index = this.roles.indexOf(current)
        return prev + index 
      },0)
      const B = (b.roles || []).reduce((prev,current) => {
        const index = this.roles.indexOf(current)
        return prev + index 
      },0)
      console.log(A)
      return A - B
    })
  }

  roles: Role[] = [
    'student',
    'trainee',
    'parent',
    'teacher',
    'staff',
    'guest',
    'admin',
    'owner' 
  ]

  roleCount = {
    'student': 0,
    'trainee': 0,
    'parent': 0,
    'teacher': 0,
    'staff': 0,
    'guest': 0,
    'admin': 0,
    'owner': 0 
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
